// Custom JS for test collection

$(document).ready(function() {
  

  
   // banner slider init on home page
   // using http://kenwheeler.github.io/slick/
    //$('.banner-slider').slick({
        //dots: true,
        //autoplaySpeed: 5000,
       // autoplay: true,
        //adaptiveHeight: true,
    //});
  
  // hide slider dots if only 1 slide
  //if ( $('.slick-track').children().length < 2) {
	//$('.slick-dots').hide();
  //}

  
  
  
});